import { AppFunctionComponent } from "../types"
import React, { memo } from "react"
import {
  CustomComponentBuilder,
  DownloadButton,
  Embed,
  EmbedType,
  Quote,
  ResponsiveImage,
  SliderBuilder,
  Video,
} from "../types"
import CustomComponentResolver from "./custom-components/custom-component.resolver"
import { EmbedDownloadButtonResolver } from "./download-button/download-button.resolver"
import QuoteResolver from "./quote/quote.resolver"
import ResponsiveImageResolver from "./responsive-image/responsive-image.resolver"
import SliderResolver from "./slider/slider.resolver"
import VideoResolver from "./video/video.resolver"

// @ts-ignore
const EmbedResolver: AppFunctionComponent<Embed> = memo(
  ({ internal, ...embed }) => {
    switch (internal.type) {
      case EmbedType.Quote:
        return <QuoteResolver {...(embed as Quote)} />
      case EmbedType.ResponsiveImage:
        return <ResponsiveImageResolver {...(embed as ResponsiveImage)} />
      case EmbedType.DownloadButton:
        return <EmbedDownloadButtonResolver {...(embed as DownloadButton)} />
      case EmbedType.Video:
        return <VideoResolver {...(embed as Video)} />
      case EmbedType.Slider:
        return <SliderResolver {...(embed as SliderBuilder)} />
      case EmbedType.CustomComponent:
        return (
          <CustomComponentResolver {...(embed as CustomComponentBuilder)} />
        )
      default:
        return null
    }
  }
)

export default EmbedResolver
